<template>
  <div class="TopTable_wrap">
    <el-table
      :data="tableData"
      :header-cell-class-name="getHeaderCellClassName"
      :header-cell-style="getHeaderCellStyle"
      :border="true"
      :stripe="true"
    >
      <el-table-column
        prop="type"
        label="平台服务"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="content"
        label="服务内容"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="standard"
        label="收费标准"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="vip"
        label="VIP权益 1999/年"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="svip"
        label="SVIP权益 2999/年"
        align="center"
      ></el-table-column>
    </el-table>

    <div class="TopTable_btn_wrap">
      <div class="TopTable_btn_left" style="cursor:pointer">立即开通</div>
      <div class="TopTable_btn_right" style="cursor:pointer">立即开通</div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";
export default {
  components: {},
  setup() {
    const tableData = [
      {
        type: "电子签章",
        content: "合同单据在线电子签章工具",
        standard: "价格/年",
        vip: "免费/折扣",
        svip: "免费/折扣",
      },
      {
        type: "CA办理",
        content: "在线办理CA数字证书",
        standard: "价格/年",
        vip: "免费/折扣",
        svip: "免费/折扣",
      },
      {
        type: "电子保函",
        content: "提供一站式投标保函服务",
        standard: "保证金额*n%/次",
        vip: "免费/折扣",
        svip: "免费/折扣",
      },
      {
        type: "平台使用费",
        content: "参与平台项目一个标段的费用",
        standard: "保证金额*n%/次",
        vip: "免费/折扣",
        svip: "免费/折扣",
      },
      {
        type: "订阅服务",
        content: "系统推送最新招采项目动态",
        standard: "价格/月、季、年免费",
        vip: "价格/月、季、年免费",
        svip: "价格/月、季、年免费",
      },
      {
        type: "广告位",
        content: "首页顶部广告位",
        standard: "价格/月、季、年免费",
        vip: "价格/月、季、年免费",
        svip: "价格/月、季、年免费",
      },
      {
        type: "",
        content: "首页顶部广告位",
        standard: "价格/月、季、年免费",
        vip: "价格/月、季、年免费",
        svip: "价格/月、季、年免费",
      },
    ];
    const data = reactive({
      tableData,
    });

    const getHeaderCellClassName = (e) => {
      const { row, columnIndex, rowIndex } = e;
      const className =
        // eslint-disable-next-line no-constant-condition
        columnIndex == 0
          ? "BaseColumnBg"
          : columnIndex == 3
          ? "VipColumnBg"
          : columnIndex == 4
          ? "SvipColumBg"
          : "BaseColumnBg";
      return className;
    };

    const getHeaderCellStyle = (e) => {
      const { row, column, rowIndex, columnIndex } = e;
      const BgColor =
        // eslint-disable-next-line no-constant-condition
        columnIndex == 0
          ? {
              "background-color": "#E2EFFD",
              "text-align": "center",
              "font-size": "18px",
              padding: "10px",
            }
          : columnIndex == 3
          ? {
              "background-color": "#FFF8E3",
              "text-align": "center",
              "font-size": "18px",
              padding: "10px",
            }
          : columnIndex == 4
          ? {
              "background-color": "#DEFFFF",
              "text-align": "center",
              "font-size": "18px",
              padding: "10px",
            }
          : {
              "background-color": "#E2EFFD",
              "text-align": "center",
              "font-size": "18px",
              padding: "10px",
            };
      return BgColor;
    };

    return {
      ...data,
      getHeaderCellClassName,
      getHeaderCellStyle,
    };
  },
};
</script>

<style scoped>
@import url("./TopTable.css");
</style>

